const CONTENT_TYPE = Object.freeze({
  json: 'json',
  text: 'text',
});

// noinspection JSUnusedGlobalSymbols
export default CONTENT_TYPE;
